export default __webpack_public_path__ + "static/media/background-portal-5.ad69449e.svg";